import { useEffect, useState } from "react";
import { getWfh } from "../../services/wfh";
import useLoader from "../../hooks/useLoader";
import Header from "../../components/Header";
import WfhList from "../../components/wfh/WfhList";
import Filter from "../../components/wfh/Filter";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import Pagination from "../../components/common/Pagination";

const WfhPage = () => {
  const [wfh, setWfh] = useState([]);
  const { hideLoader, showLoader } = useLoader();
  const [pagination, setPagination] = useState({});
  const [activeFilters, setActiveFilters] = useState({ user_status: "1" });
  const [page, setPage] = useState(1);

  const fetchWfh = async (pageNo = 1, params = {}) => {
    try {
      showLoader();
      const res = await getWfh(pageNo, params);

      if (
        res?.status === 200 &&
        res?.data?.data?.records &&
        Array.isArray(res.data.data.records)
      ) {
        setWfh(res.data.data.records);
        setPagination(res.data?.data?.pagination || {});
      } else {
        setWfh([]);
        console.warn("Unexpected response format:", res);
      }
    } catch (error) {
      console.error("Error fetching wfhs:", error);
      setWfh([]);
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    fetchWfh(page, activeFilters);
    // eslint-disable-next-line
  }, [page, activeFilters]);

  const filterWfh = (params = {}) => {
    setActiveFilters({ ...params });
    setPage(1);
  };

  const handleExport = async (exportParams = {}) => {
    try {
      showLoader();
      const response = await getWfh(1, exportParams);
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "wfh.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log("error while exporting wfh", error);
    } finally {
      hideLoader();
    }
  };

  const addButton = {
    allowedRoles: ["employee"],
    link: "/wfh/apply",
    text: "New Request",
    icon: <AddBoxOutlinedIcon fontSize="small" />,
  };

  return (
    <div>
      <Header title="WFH" addButton={addButton} />
      <Filter onFilter={filterWfh} exportWfh={handleExport} />
      <WfhList
        wfhData={wfh}
        onFilter={filterWfh}
        activeFilters={activeFilters}
      />
      {pagination && wfh.length > 0 && (
        <Pagination
          totalPages={pagination.totalPages}
          currentPage={Number(pagination.pageNo)}
          perPage={Number(pagination.perPage)}
          totalRecords={pagination.totalRecords}
          onPageChange={setPage}
        />
      )}
    </div>
  );
};

export default WfhPage;
